import { app } from '../../../../../bootstrap/core';
import { dwsCanceledState } from './canceled.state';
import { dwsCanceledComponent } from './canceled.component';

app.config(dwsCanceledState);
app.component(dwsCanceledComponent.name, dwsCanceledComponent);
